<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(document).ready(function () {
    $(".faq-question").on("click", function () {
        const $faqItem = $(this).closest(".faq-item"); // Get the parent .faq-item
        const $answer = $faqItem.find(".faq-answer");
        const $toggle = $(this).find(".faq-toggle");

        // Close all other FAQ items with smooth animation
        $(".faq-item").not($faqItem).removeClass("active")
            .find(".faq-answer").slideUp();

        $(".faq-toggle").not($toggle).text("+");

        // Toggle the current FAQ item with smooth animation
        if ($faqItem.hasClass("active")) {
            $faqItem.removeClass("active");
            $answer.slideUp();
            $toggle.text("+");
        } else {
            $faqItem.addClass("active");
            $answer.slideDown();
            $toggle.text("–");
        }
    });
});

var ajaxSearchField = document.getElementById('ajaxSearchField');
if (ajaxSearchField) {
  ajaxSearchField.addEventListener('input', function(e) {
    var query = e.target.value;

    if(query.length > 2) { // Start search after 3 characters
      fetch(`/search?q=${encodeURIComponent(query)}*&type=page&view=json`)
        .then(response => response.json())
        .then(data => {
          var results = data.results.filter(result => {
            // Assuming your metafield is 'namespace.key'
            return page.metafields.custom.only_ingredient(query);
          });

          displayResults(results);
        });
    }
  });
}

function displayResults(results) {
  var resultContainer = document.getElementById('searchResults');
  resultContainer.innerHTML = ''; // Clear previous results

  results.forEach(result => {
    var div = document.createElement('div');
    div.textContent = result.title; // Adjust as needed to display desired info
    resultContainer.appendChild(div);
  });
}

$('.testi-slide').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


